/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { UsWidgets } from 'components/us-widgets'
import { ArticleTeasers, SortMode } from '@ta-interaktiv/react-article-teasers'
import { Accordion } from 'semantic-ui-react'
import Tab from 'components/tab'
import { Link } from '@ta-interaktiv/contentbricks'

import { qanda } from './qa'

const isMobile = window.innerWidth <= 768

// TODO Set the correct article ID here
const ARTICLE_ID = '111633450183'

const QandA = ({ q }) => (
  <div className='qa'>
    <div className='question'>{q.q}</div>
    <div className='answer'>{q.a}</div>
  </div>
)
export function AppComponent() {
  const [activeIndex, setActiveIndex] = React.useState([])

  // handle Funktion
  const handleClick = (e, titleProps) => {
    const { index } = titleProps
    // const newIndex = activeIndex === index ? -1 : index
    // this.setState({ activeIndex: newIndex })
    const openIndex = activeIndex.indexOf(index)
    console.log('openIndex: ', openIndex)
    if (openIndex === -1) {
      setActiveIndex([...activeIndex, index])
    } else {
      console.log('activeIndex', openIndex, activeIndex)
      const newArray = activeIndex.filter(idx => idx !== index)
      setActiveIndex(newArray)
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'toggle tab: ' + titleProps.index
    })
  }

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui titleImage'>
        <div className='ui container cover'>
          <div className='ui header'>
            <h1>So wählten die Amerikaner</h1>
            <h2>
              Der 46. Präsident, 35 Senatoren, ein neues Repräsentantenhaus:
              Hier finden Sie alle Resultate auf einen Blick.
            </h2>
          </div>
        </div>
        <div className='candidatetWrapper'>
          <div className='bidenLeft' />
          <div className='trumpRight' />
        </div>
      </header>

      {/* <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>US-Präsidentenwahl</h1>
            <h2>
              Nullam dictum felis eu pede mollis pretium. Integer tincidunt.
              Cras dapibus. Vivamus elementum semper nisi. Donec quam felis,
              ultricies nec, pellentesque eu, pretium quis, sem.
            </h2>
          </div>
        </div>
      </header> */}

      <div className='ui vertical fitted segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Patrick Vögeli, Marc Brupbacher</div>
            <div className='ta updated'>
              Grafiken werden bis das Endergebnis feststeht, laufend
              aktualisiert.
            </div>
          </div>
          <div className='ta text'>
            <p>
              Nach einem beispiellosen Wahlkampf hat Joe Biden die Wahl in den
              USA gewonnen.
            </p>
          </div>
        </div>
      </div>
      <div className='ui vertical segment'>
        <div className='ui container'>
          <UsWidgets
            chartType='kombination-wahlmaenner-karte'
            title='Joe Biden wird der nächste US-Präsident'
          />
        </div>
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p style={{ paddingBottom: '2rem' }}>
              Neben dem Präsidenten stehen alle 435 Sitze im Repräsentantenhaus
              und 35 der 100 Sitze im Senat zur Wahl.
            </p>
          </div>
        </div>
      </div>
      <div className='ui vertical segment congressContainer'>
        <div className='ui container'>
          <div className='titleWrapper'>
            <img
              src={require('../../images/icon-congress.svg')}
              className='ui fluid image icon'
            />
            <h3
              className='ui header small infographic chart'
              style={{ marginTop: '0.5rem', color: '#575247' }}
            >
              Kongresswahl
            </h3>
          </div>
          <div className='ui grid stackable'>
            <div className='eight wide column'>
              <UsWidgets
                chartType='repraesentantenhaus'
                title='Repräsentantenhaus'
                subtitle='Umfragen Repräsentantenhaus'
                graphicText='435 Sitze – Zahl der Abgeordneten pro Bundesstaat nach Bevölkerungsgrösse, Neuwahl alle zwei Jahre.'
              />
            </div>
            <div className='eight wide column'>
              <UsWidgets
                chartType='senat'
                title='Senat'
                subtitle='Umfragen Senat'
                graphicText='100 Sitze – zwei Senatoren pro Bundesstaat; Amtszeit sechs Jahre, alle zwei Jahre wird ca. ein Drittel (grafisch hervorgehoben) neu gewählt.'
              />
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical segment qa'>
        <div className='ui text container'>
          <div className='ta text'>
            {/* <div className='quote-element'> */}
            <h3 className='titleQandA'>Die wichtigsten Fragen und Antworten</h3>
            {/* </div> */}

            {/* <h3 className='question'>Die wichtigsten Fragen und Antworten</h3> */}

            <Accordion fluid styled>
              {qanda.map((q, index) => (
                <>
                  {isMobile && (
                    <div className={'qaList' + index}>
                      <Tab
                        activeIndex={activeIndex}
                        index={index}
                        handleClick={handleClick}
                        title={q.q}
                        // flag={q.n}
                        articleId={ARTICLE_ID}
                      >
                        {/* <div className='question'>{q.q}</div> */}
                        {q.a}
                      </Tab>
                    </div>
                  )}
                  {!isMobile && <QandA q={q} />}
                </>
              ))}
            </Accordion>
          </div>
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        questions={['Wie nützlich finden Sie diese Resultate-Übersicht?']}
        credits={[
          ['Digitale Umsetzung', 'Patrick Vögeli'],
          [
            'Daten',
            'US-TV-Sender: CNN. Umfragewerte: <a href="https://www.270towin.com/2020-polls-biden-trump/">270toWin</a> aggregiert Umfragen zu Präsidentschafts- und Kongresswahlen verschiedener Institute und Medien und bildet daraus einen eigenen Durchschnittswert.'
          ],
          ['Grafiken', 'dpa-ElectionsLive']
        ]}
      >
        <div
          className='ui container articleTeaser'
          style={{ margin: isMobile ? '1.2em 0 3em' : '0 0 3em' }}
        >
          <h4 className='teaser'>Weitere Beiträge zum Thema</h4>
          <ArticleTeasers
            sorting={SortMode.REVERSE_CHRONOLOGICALLY_BY_CREATION_DATE}
            numberOfCards={isMobile ? 'two' : 'three'}
            articleIds={[
              '873790891443',
              '753696680312',
              '439438689799',
              '741993473839',
              '216933767180'
            ]}
          />
        </div>
      </Footer>
    </div>
  )
}
